import { TemplatePage } from './types';

const live_streaming_cooking_show_theme: TemplatePage = {
  header: {
    color: '#B5D6DB',
    icon: 'images/video-templates/food-restaurants.jpg',
    title: 'Live Stream Templates — Cooking Show Theme',
    title_meta: 'Free Live Stream Overlay Templates — Cooking Show Theme',
    description_meta:
      'Take your food-related show to the next level with Wave.video’s collection' +
      ' of editable cooking-show-themed templates.',
    description:
      'Take your food-related show to the next level with our editable cooking-show-themed' +
      ' templates. Leave your live streaming audience in awe without effort!'
  },
  footer: {
    category: 'Live Stream Cooking Show Theme',
    description:
      'Thanks to Wave.video’s themed packs of customizable templates, you will easily make' +
      ' your live streams more professional-looking and engaging. Wow your audience with' +
      ' branded thumbnails, overlays, intros, lower thirds, and countdowns without hiring' +
      ' a professional designer. Becoming a top-notch live streamer has never been easier!'
  },
  content: [
    {
      type: 'templates',
      title: 'Live Stream Templates — Cooking Show Theme',
      search: { name: 'CookingShowTheme', tags: 'CookingShowTheme' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_cooking_show_theme;
